import { CardWrapper, ListWrapper, Title, Wrapper } from "./styles";
import { useLocation } from "react-router-dom";
import { StarIcon } from "../Icons/Star";
import { useTranslation } from "react-i18next";

interface ICard {
  name: string;
  text: string;
  link: string;
}

const Card: React.FC<ICard> = ({ name, text, link }) => {
  return (
    <CardWrapper href={link} target="_blank">
      <div>{new Array(5).fill("").map((_) => StarIcon)}</div>
      <div id="bold">{name}</div>
      <p>{text}</p>
    </CardWrapper>
  );
};

export const PrecededYouSection = () => {
  const { t } = useTranslation("home");

  const location = useLocation();

  const pageKey = location.pathname.includes("hospita")
    ? "hostPage"
    : "studentPage";

  const hostTitle = t(`${pageKey}.precededYou.title`);

  const links =
    pageKey === "studentPage"
      ? [
          "https://g.co/kgs/heLnSd",
          "https://g.co/kgs/hGkzt7",
          "https://g.co/kgs/YzEc4j"
        ]
      : [
          "https://g.co/kgs/umtxsV",
          "https://g.co/kgs/pkeiPa",
          "https://g.co/kgs/YzEc4j"
        ];

  return (
    <Wrapper>
      <div>
        <Title>{hostTitle}</Title>
        <ListWrapper>
          <Card
            name={t(`${pageKey}.precededYou.name1`)}
            text={t(`${pageKey}.precededYou.text1`)}
            link={links[0]}
          />
          <Card
            name={t(`${pageKey}.precededYou.name2`)}
            text={t(`${pageKey}.precededYou.text2`)}
            link={links[1]}
          />
          <Card
            name={t(`${pageKey}.precededYou.name3`)}
            text={t(`${pageKey}.precededYou.text3`)}
            link={links[2]}
          />
        </ListWrapper>
      </div>
    </Wrapper>
  );
};
